import { Component, OnInit } from '@angular/core';
import { tradeDeskTabs } from '../tradedeskTabs/tradedeskTabs.component';
import { MainUIServiceService } from '../../services/main-uiservice.service';

@Component({
  selector: 'mobile-trade-desk-tabs',
  template: require('./mobile-trade-desk-tabs.component.html'),
  styles: [require('../quotePanelTabs/quotePanelTabs.component.css'),require('./mobile-trade-desk-tabs.component.css')]
})
export class MobileTradeDeskTabsComponent extends tradeDeskTabs {

  constructor(protected mainUIService:MainUIServiceService ) { super(mainUIService) }

}
